import "./TradingViewComponent.scss";
import {TradingViewService} from "../../services/TradingViewService";
import {Optional} from "../../../../js/util/Optional";
import {IDoCheck, IOnChanges, IOnChangesObject, IOnDestroy, IPostLink, IRootElementService} from "angular";
import {ReplaySubject} from "rxjs/ReplaySubject";
import {
    ChartingLibraryFeatureset,
    ChartingLibraryWidgetOptions,
    IChartingLibraryWidget, Nominal,
    ResolutionString
} from "../../../../../vendor/tradeview/charting_library";
import {TradingViewDataPoint} from "../../types/DataFeedTypes";
import {TradingViewQuoteFeedService} from "../../services/TradingViewQuoteFeedService";
import {isLocal} from "../../helper/util";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";
import {BackOffice} from "../../../../types/BackOffice";

// interface CreatedCallbackPayload {
//     api: ChartApi;
// }

// type CreatedCallback = (payload: CreatedCallbackPayload) => void;

export const TradingViewChart = "tradingViewChart";

export function tradingViewChart() {
    return {
        templateUrl: "app/components/tradeview/components/chart/TradingViewComponent.html",
        transclude: {
            toolbar: "?tfChartToolbar",
            footer: "?tfIqChartFooter"
        },
        bindings: {
            symbol: "<",
            disableSearch: "<",
            data: "<",
            theme: "<",
            showHud: "<",
            height: "<",
            onCreate: "&",
            onChange: "&",
            onDestroy: "&"
        },
        controller: TwComponentController,
        controllerAs: "ctrl"
    };
}

export class TwComponentController implements IPostLink, IDoCheck, IOnChanges, IOnDestroy {

    /** @input */
    public readonly symbol: string;

    /** @input */
    public readonly data: Array<TradingViewDataPoint> | null;

    /** @input */
    public readonly theme: any;

    /** @input */
    public disableSearch = false;

    /** @input */
    public readonly height = "100%";

    // /** @output */
    // public readonly onCreate: CreatedCallback;

    /** @output */
    public readonly onChange: Function;

    /** @output */
    public readonly onDestroy: Function;

    public readonly created$ = new ReplaySubject<void>(1);

    private chartHeight: number;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    private _isHome = true;
    private service: TradingViewService;
    private chartContainer: HTMLElement;
    private readonly id: string;
    private engine: IChartingLibraryWidget;
    private defaultConfig: ChartingLibraryWidgetOptions;
    private tradingViewQuoteFeedService: TradingViewQuoteFeedService;

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       tradingViewService: TradingViewService,
                       tradingViewQuoteFeedService: TradingViewQuoteFeedService,
                       private readonly currentUserService: CurrentUserService) {
        this.service = tradingViewService;
        this.id = (Math.random() * 1000000).toFixed(0);
        this.$element.attr("instance-id", this.id);
        this.tradingViewQuoteFeedService = tradingViewQuoteFeedService;
        this.defaultConfig = this.buildConfig();
    }

    public $postLink() {
        this.chartContainer = this.$element[0].querySelector(".tf-trading-view-container") as HTMLElement;
        this.setElementHeight();
        const user = this.currentUserService.user;
        if (user.subscriptions.length === 0 && user.backOffice === BackOffice.PHILLIP) {
            this.renderFxeDefaultChart();
        } else {
            const config = this.generateConfig();
            this.engine = this.service.createEngine( this.engineConfig(config, this.chartContainer));
        }

        // this.configureEngine(this.engine);
        // if (this.symbol != null) {
        //     this.upDate(this.symbol);
        // }
        // this.addEventListeners();
    }

    private renderFxeDefaultChart(): void {
        const container = document.createElement("div");
        container.className = "tradingview-widget-container";
        container.setAttribute("style", "height:100%;width:100%");

        const widgetDiv = document.createElement("div");
        widgetDiv.className = "tradingview-widget-container__widget";
        widgetDiv.setAttribute("style", "height:calc(100% - 32px);width:100%");

        container.appendChild(widgetDiv);

        // @ts-ignore
        this.$element[0].querySelector(".tf-trading-view-container").appendChild(container);

        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
        script.async = true;

        script.text = JSON.stringify({
                                         autosize: true,
                                         symbol: "ASX:XJO",
                                         interval: "D",
                                         timezone: "Etc/UTC",
                                         theme: "light",
                                         style: "1",
                                         locale: "en",
                                         allow_symbol_change: true,
                                         calendar: false,
                                         support_host: "https://www.tradingview.com"
                                     });
        // @ts-ignore
        this.$element[0].querySelector(".tradingview-widget-container").appendChild(script);
    }

    private generateConfig(): ChartingLibraryWidgetOptions {
        return Object.assign({}, this.buildConfig());
    }

    private configureEngine(engine: IChartingLibraryWidget) {
        engine.setSymbol(`${this.symbol}`, "1D" as ResolutionString, () => {
           console.log("setting symbol to:", this.symbol);
           engine.symbolSync();
        });
    }

    public $onChanges(changes: IOnChangesObject) {
        if (changes.data != null || (changes.symbol != null && this.symbol != null)) {
            if (this.engine != null) {
                this.upDate(this.symbol);
            }
        }
        if (changes.height != null && !changes.height.isFirstChange()) {
            this.setElementHeight();
        }
        if (changes.theme != null && this.theme != null) {
            this.updateTheme(this.theme);
        }
    }

    private buildConfig(): ChartingLibraryWidgetOptions {
        console.log("is local is", isLocal);
        const disabled_features: ChartingLibraryFeatureset[] = this.disableSearch ? ["header_symbol_search", "chart_zoom", "pinch_scale", "header_resolutions"] : ["chart_zoom", "pinch_scale", "header_resolutions"];

        return {
            container: this.$element[0].querySelector(".tf-trading-view-container") as HTMLElement,
            locale: "en",
            library_path: "/tradefloor/vendor/tradeview/charting_library/",
            datafeed: this.tradingViewQuoteFeedService.getDataFeed(),
            symbol: `${this.symbol ? this.symbol : "CBA"}`,
            timezone: "Australia/Sydney",
            interval: "1D" as ResolutionString,
            autosize: true,
            debug: isLocal,
            symbol_search_request_delay: 1000,
            time_frames: [
                { text: "1y", resolution: "1D", description: "1 Years", title: "1yr" },
                { text: "3y", resolution: "1D", description: "3 Years", title: "3yr" },
                { text: "5y", resolution: "1D", description: "5 Years", title: "5yr" },
                { text: "1h", resolution: "1", description: "1 Hour" },
                { text: "3h", resolution: "1", description: "3 Hours" },
                { text: "1d", resolution: "1", description: "1 Day", title: "1d" },
                { text: "3d", resolution: "1", description: "3 Days", title: "3d" },
                { text: "5d", resolution: "5", description: "5 Days", title: "5d" },
                { text: "1m", resolution: "1D", description: "1 Month", title: "1m" },
                { text: "3m", resolution: "1D", description: "3 Month", title: "3m" },
                { text: "6m", resolution: "1D", description: "6 Month", title: "6m" },
            ],
            charts_storage_url: "/tradefloor/api/ui-configuration/tradeview-template",
            charts_storage_api_version: "1.1",
            enabled_features: ["show_spread_operators", "study_templates", "chart_template_storage", "header_saveload"],
            overrides: {
                "scalesProperties.textColor": "#FF0000",
                "scalesProperties.fontSize": 14,
            },
            favorites: {
                // intervals: ["1D", "3D", "3W", "W", "M"] as any,
                // indicators: ["Awesome Oscillator", "Bollinger Bands"] as any,
                // drawingTools: ["LineToolBrush", "LineToolCallout", "LineToolCircle"] as any,
                chartTypes: ["Area", "Candles"],
            },
            disabled_features
        };
    }

    private setElementHeight() {
        console.debug("Changing Chart Height");
        const height = Optional.of(this.height).orElse("100%");
        this.$element.css("height", height);
    }

    private updateTheme(theme: any) {
        // if (theme != null && this.engine != null) {
        //     const themeHelper = this.service.createThemeHelper(this.engine);
        //     const chartSettings = themeHelper.settings.chart;
        //     Object.assign(chartSettings, theme);
        //     themeHelper.update(this.engine);
        // }
    }

    public $doCheck() {
        this.calculateChartHeight();
    }

    private calculateChartHeight() {
        // doCheck can be called before everything has been initialized
        if (this.chartContainer == null) {
            return;
        }

        const toolbar = Optional.of(this.$element[0]).map((el) => el.querySelector(".toolbars"));
        const range = Optional.of(this.$element[0]).map((el) => el.querySelector(".footer"));
        let height = this.$element[0].clientHeight;
        toolbar.map(el => el.clientHeight).ifPresent((elHeight) => height -= elHeight);
        range.map(el => el.clientHeight).ifPresent((elHeight) => height -= elHeight);

        let newHeight: string | null = null;

        if (this.chartHeight == null) {
            this.chartHeight = height;
            newHeight = height + "px";
        } else {
            const diff = this.chartHeight - height;
            const absDiff = Math.abs(diff);
            if (absDiff > 5) {
                this.chartHeight = height;
                newHeight = height + "px";
            }
        }

        if (newHeight != null) {
            this.chartContainer.style.height = newHeight;
        }
    }

    // private addEventListeners() {
    //     // this.engine.addEventListener("layout", (params) => {
    //     //     this.updateActiveStudies();
    //     //     this.layout$.next(params.layout);
    //     // });
    //     this.engine.addEventListener("symbolChange", this.symbolChanged.bind(this));
    // }
    //
    // public onDraw(fn: ChartIQEngineInterceptor): InjectionDescriptor {
    //     return this.engine.append("draw", fn);
    // }

    // public onDrawingsChanged(fn: Function) {
    //     return this.engine.addEventListener("undoStamp", (params) => fn(params.before, params.after));
    // }

    // private updateActiveStudies() {
    //     const studies = this.activeStudies;
    //     this.studies$.next(studies);
    // }

    // private get activeStudies(): Array<ActiveStudy> {
    //     const activeStudies = this.engine.layout.studies || {};
    //     return Object.keys(activeStudies)
    //                  .map(key => ActiveStudy.of(key, activeStudies[key]));
    // }

    /* Only cares when the non-master symbol is changed as we have other callbacks for the master chart changing */
    // private symbolChanged(params: SymbolChangeCallbackParams) {
    //     switch (params.action) {
    //         case SymbolChangeSource.ADD_SERIES:
    //         case SymbolChangeSource.REMOVE_SERIES:
    //             this.seriesChanged();
    //             break;
    //         case SymbolChangeSource.MASTER:
    //             return;
    //         default:
    //             throw Error(`Unknown symbol change source: ${params.action}`);
    //     }
    // }

    // private seriesChanged() {
    //     this.$timeout(() => {
    //         const current = this.currentSeries();
    //         this.series$.next(current);
    //     });
    // }

    private createChart(symbol: string) {
        // const options: ChartInitOptions = {
        //     masterData: this.data
        // };
        // this.engine.loadChart(symbol, options, () => this.chartLoaded(symbol));
        // this.created$.next(void 0); // don't ask
        // this.updateTheme(this.theme);
        console.log("I'm setting symbol", symbol);
        this.engine.setSymbol(`${symbol}`, "1D" as ResolutionString, () => {
            console.log("create chart with symbol:", symbol);
            this.engine.symbolSync();
        });
    }

    private upDate(symbol: string) {
        console.log("I'm updating symbol", symbol);
        if (this.engine.activeChart()) {
            this.engine.activeChart().setSymbol(symbol);
        } else {
            this.engine.setSymbol(`${symbol}`, "1D" as ResolutionString, () => {
                console.log("create chart with symbol:", symbol);
            });
        }
    }

    private chartLoaded(symbol: string) {
        this.onChange({symbol});
        this.patchSymbol(symbol);
    }

    // TODO This is a patch for a bug that seems to have happened in the 5.2.0 release,
    // TODO so may not be needed if we're past that point now
    private patchSymbol(symbol: string) {
        const chartTitle = this.$element.find("#iconsTemplate > div.stx-panel-title.chart-title");
        chartTitle.text(symbol);
    }

    // public refreshStudy(key: string) {
    //     const study = this.activeStudies.find(s => s.key === key);
    //     if (study != null) {
    //         const descriptor = study.descriptor;
    //         const params = {
    //             name: descriptor.name,
    //             sd: descriptor,
    //             stx: this.engine,
    //             inputs: descriptor.inputs,
    //             outputs: descriptor.outputs,
    //             parameters: descriptor.parameters
    //         };
    //         this.studyService.refreshStudy(params);
    //     }
    // }

    // public refreshAllStudies() {
    //     this.activeStudies
    //         .map(s => s.key)
    //         .forEach(this.refreshStudy.bind(this));
    // }

    // public removeAllStudies() {
    //     const studies = this.engine.layout.studies || {};
    //     Object.keys(studies).forEach((key) => {
    //         const study = studies[key];
    //         this.removeStudy(study);
    //     });
    // }

    // public editStudy(descriptor: ChartIQStudyDescriptor) {
    //     const params = {
    //         name: descriptor.name,
    //         sd: descriptor,
    //         stx: this.engine,
    //         inputs: descriptor.inputs,
    //         outputs: descriptor.outputs,
    //         parameters: descriptor.parameters
    //     };
    //     this.studyService.editStudy(params);
    // }

    // public addSeries(series: AddSeriesParams, cb?: Function) {
    //     const addedCallback = () => {
    //         if (cb != null) {
    //             cb();
    //         }
    //     };
    //     this.engine.addSeries(series.symbol, series, addedCallback);
    // }

    // public removeSeries(series: string | AddSeriesParams) {
    //     if (typeof series === "string") {
    //         this.engine.removeSeries(series);
    //     } else {
    //         this.engine.removeSeries(series.symbol);
    //     }
    // }

    // public currentSeries(): Array<AddSeriesParams> {
    //     return Optional.of(this.engine)
    //                    .map(engine => engine.chart)
    //                    .map(chart => chart.series)
    //                    .map(series => Object.values(series))
    //                    .orElse([])
    //                    .map(entry => entry.parameters)
    //                    .sort((a, b) => a.symbol.localeCompare(b.symbol));
    // }

    // TODO This should be a merge rather than a heavy handed remove and re-add for everything regardless of if it
    // TODO has actually changed or not
    // public replaceSeries(series: Array<AddSeriesParams>) {
    //     const current = this.currentSeries();
    //     current.forEach(this.removeSeries.bind(this));
    //     series.forEach((s) => this.addSeries(s));
    // }

    // public get canUndo(): boolean {
    //     return this.engine.undoStamps.length > 0;
    // }

    // public undo() {
    //     this.engine.undo();
    // }

    // public setPeriod(params: ChartIQPeriodicity) {
    //     this.engine.setPeriodicity(params);
    // }
    //
    // public currentPeriod(): ChartIQPeriodicity {
    //     const layout = this.engine.layout;
    //     return {
    //         period: layout.periodicity,
    //         interval: layout.interval,
    //         timeUnit: layout.timeUnit || null
    //     };
    // }
    //
    // public linebreakConfig(): number | null {
    //     if (this.engine.layout.priceLines != null) {
    //         return this.engine.layout.priceLines;
    //     } else {
    //         return this.engine.chart.defaultChartStyleConfig.priceLines;
    //     }
    // }
    //
    // public rangeBarsConfig(): number | null {
    //     if (this.engine.layout.range != null) {
    //         return this.engine.layout.range;
    //     } else {
    //         return this.engine.chart.defaultChartStyleConfig.range;
    //     }
    // }
    //
    // public renkoConfig(): number | null {
    //     if (this.engine.layout.renko != null) {
    //         return this.engine.layout.renko;
    //     } else {
    //         return this.engine.chart.defaultChartStyleConfig.renko;
    //     }
    // }
    //
    // public kagiConfig(): number | null {
    //     if (this.engine.layout.kagi != null) {
    //         return this.engine.layout.kagi;
    //     } else {
    //         return this.engine.chart.defaultChartStyleConfig.kagi;
    //     }
    // }
    //
    // public pointAndFigureConfig(): PointAndFigureConfig | null {
    //     if (this.engine.layout.pandf != null) {
    //         return this.engine.layout.pandf;
    //     } else {
    //         return this.engine.chart.defaultChartStyleConfig.pandf;
    //     }
    // }
    //
    // public updateLayout(fn: Consumer<ChartIQEngineInstanceLayout>) {
    //     fn(this.engine.layout);
    //     this.engine.changeOccurred("layout");
    //     this.engine.createDataSet();
    //     this.engine.draw();
    // }
    //
    // public captureImage(mimeType: ImageMimeType = ImageMimeTypes.PNG): Promise<Blob> {
    //     const crosshair = this.crosshairIsShown();
    //     this.hideCrosshairs();
    //     const canvas = this.engine.chart.canvas;
    //     const context = canvas.getContext("2d")!;
    //     context.save();
    //     this.addCanvasBackground(canvas);
    //     return new Promise((resolve, reject) => {
    //         canvas.toBlob((b: Blob | null) => {
    //             if (b !== null) {
    //                 resolve(b);
    //             } else {
    //                 reject();
    //             }
    //             this.crosshairVisible(crosshair);
    //             context.restore();
    //         }, mimeType);
    //     });
    // }
    //
    // private addCanvasBackground(canvas: HTMLCanvasElement): HTMLCanvasElement {
    //     const ctx = canvas.getContext("2d")!;
    //     const initialOperation = ctx.globalCompositeOperation;
    //     ctx.globalCompositeOperation = "destination-over";
    //     const background = this.backgroundColour();
    //     ctx.fillStyle = background;
    //     ctx.strokeStyle = background;
    //     ctx.fillRect(0, 0, canvas.width, canvas.height);
    //     ctx.stroke();
    //     ctx.globalCompositeOperation = initialOperation;
    //     return canvas;
    // }
    //
    // private backgroundColour(): string {
    //     const helper = this.service.createThemeHelper(this.engine);
    //     return helper.settings.chart["Background"].color!;
    // }

    private engineConfig(config: ChartingLibraryWidgetOptions, container: Element): ChartingLibraryWidgetOptions {
        console.log("CREATING ENGINE CONFIG", config);

        return Object.assign({}, { container }, config);
    }

    public $onDestroy() {
        // this.engine.destroy();
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.onDestroy({id: this.id});
        this.tradingViewQuoteFeedService.destroy();
    }

}
